import React, {Component} from 'react';
import {Link} from 'react-router-dom';
class CollectionNav extends Component {
  orderCollections() {
    // Order by sort_order
    var ord_collections = this.props.collections.sort(function(a, b) {
      if (a['sort_order'] < b['sort_order']) {
        return -1;
      }
      return 1;
    });
  }

  render() {
    var collections = this.props.collections.map(collection => {
      //Get rid of store name in collection title
      var title = collection['display_name'];
      var navColor = this.props.style.navActive;
      if (!collection['shopify_collection_id']) {
        navColor = this.props.style.navInactive;
      }
      //Don't show homepage title
      if (title === 'Homepage') {
        return <div />;
      }
      if (collection.slug === '') {
        return (
          <li
            className="Collection__list Collection__inactive"
            id={collection.id}
            key={'collection-' + collection.id}>
            <span style={{color: navColor}}>{title}</span>
          </li>
        );
      } else {
        return (
          <li
            className="Collection__list Collection__active"
            id={collection.id}
            key={'collection-' + collection.id}
            onClick={this.props.handleMenuClose}>
            <Link
              to={'/collections/' + collection.slug}
              style={{textDecoration: 'none', color: navColor}}>
              <span style={{color: navColor}}>{title}</span>
            </Link>
          </li>
        );
      }
    });
 
    if (this.props.isMenuOpen) {
      return (
        <div
          className={`Menu Menu-mobile ${
            this.props.isMenuOpen ? 'Menu--open' : ''
          }`}
          style={this.props.style.sideBar}>
          <ul
            className="Collection Collection__nav-mobile"
            style={this.props.style.sideBar}>
            <button
              onClick={this.props.handleMenuClose}
              className="Menu__close">
              ×
            </button>
            <li className="Collection__head_title">
              <h5>
                <strong>Shop By</strong>
              </h5>
            </li>
            {collections}
          </ul>
        </div>
      );
    }

    return (
      <ul
        className="Collection Collection__desktop"
        style={this.props.style.sideBar}>
        <li className="Collection__head_title">
          <h5>
            <strong>Shop By</strong>
          </h5>
        </li>
        {collections}
      </ul>
    );
  }
}

export default CollectionNav;



// WEBPACK FOOTER //
// ./src/components/CollectionNav.js